(ns app.front.ui.status
  "style definitions related to displaying the status of something.

  Semantic status colors (single source of truth):
    status-success     #00A832  Success, Pass, Granted, Allowed, OK, Positive response
    status-warning     #FADF0B  Warning, Draft, Partial. No blockage but needs attention
    status-error       #EC0927  Error, Failure, Block, Fatal, Negative response
    status-informative #0F3FD2  Neutral attention; task, waiting for non-blocking input
    status-neutral-01  #CDD1D4  Default, Normal
    status-neutral-02  #E7ECFB  Neutral, process ongoing (e.g. in progress)
    status-attention   #FB9232  Awaiting user action required to proceed

  All colors are defined as CSS custom properties in _colors.scss and exposed
  via Tailwind as bg-status-*, border-status-*, text-status-* classes.")

(def status->border-color-class
  {:critical     "border-status-error"
   :error        "border-status-error"
   :warning      "border-status-warning"
   :notification "border-status-neutral-02"
   :task         "border-status-informative"
   :informative  "border-status-informative"
   :ok           "border-status-success"
   :success      "border-status-success"
   :attention    "border-status-attention"
   :inactive     "border-status-neutral-01"
   :primary      "border-ui-night-sky"
   :active       "border-ui-violet-100"})

(def status->bg-color-class
  {:critical     "bg-status-error"
   :error        "bg-status-error"
   :warning      "bg-status-warning"
   :notification "bg-status-neutral-02"
   :task         "bg-status-informative"
   :informative  "bg-status-informative"
   :ok           "bg-status-success"
   :success      "bg-status-success"
   :attention    "bg-status-attention"
   :inactive     "bg-status-neutral-01"
   :primary      "bg-ui-night-sky"
   :active       "bg-ui-violet-100"})

(def status->text-color-class
  "Text color that provides good contrast on the corresponding status background."
  {:critical     "text-ui-white"
   :error        "text-ui-white"
   :warning      "text-ui-night-sky-100"
   :notification "text-ui-night-sky-100"
   :task         "text-ui-white"
   :informative  "text-ui-white"
   :ok           "text-ui-white"
   :success      "text-ui-white"
   :attention    "text-ui-night-sky-100"
   :inactive     "text-ui-night-sky-100"
   :primary      "text-ui-white"
   :active       "text-ui-white"})

(defn status->bg-text-color-classes
  "Get both text and background color classes at once"
  [status]
  (str (status->bg-color-class status) " " (status->text-color-class status)))
